<template>
  <div>
    <q-card style="padding: 15px" v-if="selectedItems.length === 0">
      <empty-value name="vehicle"></empty-value>
    </q-card>

    <div class="content-table" ref="table" v-else>
      <q-btn
        v-if="selectedItems.length > 0"
        class="glossy custom-item-icon-3 left-0"
        style="margin-left: -10px"
        @mousedown="shiftLeft()"
        @mouseup="shiftLeftEnd()"
        round
        color="primary"
        icon="fas fa-arrow-left"
      />
      <q-btn
        v-if="selectedItems.length > 0"
        class="glossy custom-item-icon-3 right-0"
        @mouseup="shiftRightEnd()"
        @mousedown="shiftRight()"
        round
        color="primary"
        icon="fas fa-arrow-right"
      />
      <q-form ref="saveVehiclesFormRef"
              @submit.prevent.stop="sendVehicles"
              @validation-error="onValidationError"
              :disabled="isLoading">
        <table>
          <thead>
          <tr>
            <th v-for="column in columns">{{ column.name }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in selectedItems" :key="item.id">
            <td v-for="column in columns" v-if="column.visible">
              <div v-if="column.val === 'delete'">
                <q-btn round color="red" icon="fas fa-trash" size="sm" @click="deleteItem(item.id)"/>
              </div>
              <div v-else-if="column.val === 'mileage'" class="fix-col input-col">
                <q-field outlined dense v-model.lazy="item.mileage"
                         :rules="[val => !!val || 'Field is required']"
                         :disable="isLoading">
                  <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                    <input :id="id" class="q-field__input" :value="value"
                           @change="e => emitValue(e.target.value)" v-money="mileageFormatForDirective"
                           v-show="floatingLabel">
                  </template>
                </q-field>
              </div>
              <div v-else-if="column.val === 'condition'" v-html="getConditionByValue(item.condition)"/>
              <div v-else-if="column.val === 'grade'" class="fix-col">
                <q-input outlined dense v-model="item.grade" type="number" min="1" max="5" step="any"
                         :disable="isLoading"/>
              </div>
              <div v-else-if="column.val === 'grade'" class="fix-col">
                <q-input outlined dense v-model="item.grade" type="number" min="1" max="5" step="any"
                         :disable="isLoading"/>
              </div>
              <div v-else-if="column.val === 'state'" class="fix-col">
                <q-input outlined dense v-model="item.state" type="text" maxlength="2"
                         :disable="isLoading"/>
              </div>
              <div v-else-if="column.val === 'company'">
                {{ item[column.val].name }}
              </div>
              <div v-else-if="column.val === 'location'">
                {{ item[column.val].name }}
              </div>
              <div v-else>{{ item[column.val] }}</div>
            </td>
          </tr>
          </tbody>
        </table>
      </q-form>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import {VMoney} from "v-money";
import EmptyValue from "@/components/EmptyValue.vue";

export default {
  name: 'SelectionList',
  components: {EmptyValue},
  props: {
    onDeleteItem: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      columns: [],
      results: [],
      isLoading: false,
      conditions: [
        {
          name: 'Above',
          val: 'excellent'
        },
        {
          name: 'Average',
          val: 'good'
        },
        {
          name: 'Below',
          val: 'fair'
        }
      ],
      mileageFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    selectionListColumns: {
      get() {
        return this.$store.state.blackbook.selectionListColumns;
      },
      set(val) {
        this.$store.commit("blackbook/SET_SELECTION_LIST_COLUMNS", val);
      },
    },
    selectedItems: {
      get() {
        return this.$store.state.blackbook.selectedItems;
      },
      set(val) {
        this.$store.commit("blackbook/SET_SELECTED_ITEMS", val);
      },
    },
    isSaveVehicles: {
      get() {
        return this.$store.state.blackbook.isSaveVehicles
      },
      set(val) {
        this.$store.commit('blackbook/SET_IS_SAVE_VEHICLES', val)
      }
    },
  },
  methods: {
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.table.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.table.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    deleteItem(id) {
      this.onDeleteItem(id)
    },
    getConditionByValue(value) {
      return this.conditions.find(condition => condition.val === value).name
    },
    onValidationError(ref) {
      this.$q.notify({
        message: 'Please fill out all required fields',
        timeout: 250,
        position: 'top-right',
        progress: true,
        type: 'negative'
      })
      ref.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      })
    },
    async sendVehicles() {
      try {
        this.isLoading = true
        const {data} = await axios.put('/blackbook', this.selectedItems.map(item => {
          return {
            vehicle_id: item.id,
            mileage: item.mileage !== null || item.mileage !== '' ? parseInt(item.mileage.replace(',', '')) : null,
            grade: item.grade !== null || item.grade !== '' ? parseFloat(item.grade) : null,
            state: item.state !== null || item.state !== '' ? item.state : null,
          }
        }))
        this.$q.notify({
          message: 'Vehicles saved successfully',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.results = data.data
        this.selectedItems = []
        this.$router.push({name: 'blackbook_show', params: {id: data.data.id}})
      } catch (error) {
        this.$q.notify({
          message: error.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.isLoading = false
        this.isSaveVehicles = false
      }
    },
  },
  watch: {
    selectionListColumns: {
      deep: true,
      immediate: true,
      handler(columns) {
        this.columns = columns.filter(col => col.visible)
      }
    },
    isSaveVehicles: {
      deep: true,
      immediate: true,
      async handler(val) {
        if (val) {
          const valid = await this.$refs.saveVehiclesFormRef.validate()
          if (valid) {
            await this.sendVehicles()
          } else {
            this.isSaveVehicles = false
          }
        }
      }
    },
  },
  directives: {money: VMoney},
}
</script>

<style scoped lang="scss">
.custom-item-icon-3 {
  z-index: 999 !important;
  position: fixed !important;
  top: 60% !important;
}

.right-0 {
  right: 0;
}

.table-cell {
  display: table-cell;
}

.none-cell {
  display: none;
}

.selected-finance {
  background: rgba(244, 67, 54, 0.5) !important;
}

.no-finance {
  background: rgba(244, 67, 54, 0.1) !important;
}

.tag-table-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  .tag-item {
    margin-right: -5px;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 50%;
  }
}

.mark-table {
  background: rgba(0, 0, 0, 0.12) !important;
}

.flip-list-move {
  transition: transform 500ms;
}

.content-table {
  position: relative;
  z-index: 1;
  overflow: auto;
}

.content-table table {
  min-width: auto !important;
  border-collapse: separate;
  border-spacing: 0;
}

.table-wrap {
  position: relative;
}

.content-table {
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  th {
    align-items: center;
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
  }

  td {
    padding: 15px 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
    cursor: auto;
  }
}

@media only screen and (max-width: 600px) {
  .content-table th,
  .content-table td {
    padding: 15px 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: left;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.container-checkbox {
  width: 18px;
  cursor: pointer;
  height: 18px;
  text-align: center;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.input-col {
  padding: 30px 10px 10px !important;
}

.fix-col {
  min-width: 100px;
}

.fix-col-lg {
  min-width: 130px;
}

.fix-col-xl {
  min-width: 170px;
}
</style>
